import React, { useState, useEffect, useRef } from "react";
import { sendData, getData } from "../../../helpers/auth";
import { InputLabelAlert } from "../../layout";
import { formatCurrency } from "../../../helpers/general";
import { uriList } from "../../../helpers/config";
import Swal, { swalError } from "../../../components/swal";
import { Modal, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { Buttons } from "../../../components/layout";

// Novo componente para input de contrato_cip com padding reduzido e largura total
export const ContratoCipInput = React.forwardRef(({ value, onChange, ...rest }, ref) => (
  <input
    ref={ref}
    value={value}
    onChange={onChange}
    maxLength={40}
    style={{
      width: "100%",
      padding: "2px",
      boxSizing: "border-box"
    }}
    {...rest}
  />
));

const Form = ({ ...props }) => {
  const [contratos, setContratos] = useState(null);
  const [clickedTr, setClickedTr] = useState({});
  const [carregando, setCarregando] = useState(true);
  const [naoEnviar, setNaoEnviar] = useState(false);

  // refs para inputs de contrato_cip
  const contratoCipRefs = useRef([]);

  useEffect(() => {
    console.log("SelPort: ", props.cpf);

    async function _buscarContratosPort() {
      if (props.exibir_contratos_port) {
        await sendData({
          uri: uriList("buscarContratosPort"),
          content: { cpf: props.cpf },
          method: "POST",
        })
          .then((res) => {
            setCarregando(false);
            if (res.status && parseInt(res.status) > 200) throw new Error();
            setContratos(res.data);
          })
          .catch((e) => {
            setClickedTr(false);
            swalError({
              title:
                "Erro ao buscar contratos de Portabilidade, não será possível gravar Proposta!",
            });
          });
      } else setCarregando(false);
    }

    _buscarContratosPort();
  }, []);

  // Foco no campo contrato_cip ao abrir tela
  useEffect(() => {
    if (
      props.exibir_contratos_port &&
      contratos &&
      contratos.length > 0 &&
      contratoCipRefs.current[0]
    ) {
      contratoCipRefs.current[0].focus();
    }
  }, [props.exibir_contratos_port, contratos]);

  function handleContrato(_contrato) {
    if (!_contrato) return;

    setClickedTr(_contrato);
  }

  function handleNrContrato(contrato, index) {
    console.log("selPort.handleNrContrato(contrato): ", contrato)
    console.log("selPort.handleNrContrato(index): ", index)
  }

  // Ao digitar no campo contrato_cip já setar o registro da tabela como clicado
  // Só permitir números e letras, sem espaço, sem caracteres especiais, até 40 caracteres
  function handleContratoCipChange(e, contrato, i) {
    let newValue = e.target.value;
    // Remove tudo que não for letra ou número (sem espaço, sem caracteres especiais)
    newValue = newValue.replace(/[^a-zA-Z0-9]/g, "");
    // Limita a 40 caracteres
    newValue = newValue.slice(0, 40);
    setContratos((prev) =>
      prev.map((c, idx) =>
        idx === i ? { ...c, contrato_cip: newValue } : c
      )
    );
    // Sempre setar o registro como clicado ao digitar
    setClickedTr({ ...contrato, contrato_cip: newValue });
  }

  function goBack() {
    if (props.goBack) props.goBack();
  }

  function submit() {
    if (!clickedTr?.nrContrato) {
      swalError({ title: "Selecione um contrato para simular", });
      return;
    }
    if (props.submit) props.submit(clickedTr);
  }

  // Função para alternar cor de fundo das linhas (zebra)
  const getRowZebraStyle = (idx, isSelected) => {
    if (isSelected) {
      // Mantém a seleção destacada
      return { backgroundColor: "#6c757d", color: "#fff" };
    }
    return {
      backgroundColor: idx % 2 === 0 ? "#f9f9f9" : "#e6eef3",
      color: "#222"
    };
  };

  // Estilo reduzido para fonte da tabela
  const tableFontStyle = { fontSize: "13px" };
  const headerFontStyle = { fontSize: "13px", fontWeight: "bold" };

  // Ajuste dos tamanhos das colunas:
  // Contrato: 96px -> 80px (reduzido ~17%)
  // Contrato CIP: 90px -> 110px (aumentado ~22%)
  // Consignatária: 200px -> 170px (reduzido ~15%)
  // CNPJ: 84px (mantido)
  // Vlr Parcela: 96px (mantido)

  // Padding horizontal de 2px para colunas alinhadas à esquerda
  const leftCellPadding = { padding: "0 2px" };

  return (
    <>
      <Modal
        size={"lg"}
        scrollable
        show={true}
        animation={false}
        backdrop="static"
        centered
      >
        <Modal.Body
          style={{
            width: "100%",
            // Remover centralização flex para voltar ao estado anterior
            //justifyContent: "center",
            //textAlign: "center",
            minHeight: "400px",
            //display: "flex",
            //alignItems: "center",
            //flexDirection: "column"
          }}
        >
          {carregando ? (
            // Voltar ao estado anterior: sem centralização flex, apenas texto simples
            <h2 style={{ opacity: "60%", margin: "40px 0", textAlign: "center" }}>
              Aguarde, carregando dados...
            </h2>
          ) : (
            <>
              {(!props.exibir_contratos_port && (
                <>
                  <div className="form-group">
                    <div style={{ pointerEvents: "none", textAlign: "center" }}>
                      <h1>Dados da Portabilidade</h1>
                    </div>
                    <hr className="mt-1" />
                  </div>

                  <div className="row">
                    <div className="form-group col-md-3" style={{ minWidth: 0 }}>
                      <InputLabelAlert
                        type="tel"
                        label="CNPJ do Banco"
                        id="nrCNPJ"
                        value={clickedTr.nrCnpj}
                        handle={(e) => {
                          setClickedTr({ ...clickedTr, nrCnpj: e.target.value });
                        }}
                        focus={true}
                        style={{ width: "112px" }} // 125px - 10%
                      />
                    </div>
                    <div className="form-group col-md-7" style={{ minWidth: 0 }}>
                      <InputLabelAlert
                        type="text"
                        label="Nome do Banco"
                        id="nmConsignataria"
                        value={clickedTr.nmConsignataria}
                        handle={(e) => {
                          setClickedTr({
                            ...clickedTr,
                            nmConsignataria: e.target.value,
                          });
                        }}
                        focus={false}
                        style={{ width: "288px" }} // 320px - 10%
                      />
                    </div>
                    <div className="form-group col-md-2" style={{ minWidth: 0 }}>
                      <InputLabelAlert
                        type="tel"
                        label="Contrato"
                        id="contrato"
                        value={clickedTr.nrContrato}
                        handle={(e) => {
                          setClickedTr({
                            ...clickedTr,
                            nrContrato: e?.target?.value?.replace(/\D/g, ""),
                          });
                        }}
                        focus={false}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-3">
                      <InputLabelAlert
                        type="tel"
                        label="Parcela Portada"
                        id="vlParcelaPort"
                        cifrao={true}
                        value={formatCurrency(clickedTr.vlParcelaPort)}
                        handle={(e) => {
                          setClickedTr({
                            ...clickedTr,
                            vlParcelaPort: formatCurrency(e.target.value),
                          });
                        }}
                        msgErro={"É necessário informar o Valor da Parcela"}
                        focus={false}
                      />
                    </div>
                    <div className="form-group col-md-3">
                      <InputLabelAlert
                        type="tel"
                        label="Orgao"
                        id="codOrgao"
                        value={clickedTr.codOrgao}
                        handle={(e) => {
                          setClickedTr({ ...clickedTr, codOrgao: e.target.value });
                        }}
                        focus={false}
                      />
                    </div>
                    <div className="form-group col-md-3">
                      <InputLabelAlert
                        type="tel"
                        label="Convênio"
                        id="cdConvenio"
                        value={clickedTr.cdConvenio}
                        handle={(e) => {
                          setClickedTr({
                            ...clickedTr,
                            cdConvenio: e.target.value,
                          });
                        }}
                        focus={false}
                      />
                    </div>
                  </div>
                </>
              )) ||
                (props.exibir_contratos_port && (
                  <fieldset className="col-12">
                    <h4
                      className="display-4 text-center font-weight-bold"
                      style={{ marginBottom: "15px", color: "#3E6C84" }}
                    >
                      Seleção de Contrato
                    </h4>
                    <div
                      className="form-group col-md-12"
                      style={{
                        overflowX: "auto",
                        minHeight: "500px",
                        maxHeight: "500px",
                        padding: 0
                      }}
                    >
                      <table
                        border="1"
                        style={{
                          cursor: "pointer",
                          minWidth: "0", // Remove minWidth para evitar scroll
                          width: "100%",
                          tableLayout: "fixed",
                          borderCollapse: "collapse",
                          borderTop: "2px solid #dee2e6",
                          ...tableFontStyle
                        }}
                      >
                        <thead style={{ position: "sticky", top: "0px", zIndex: 2 }}>
                          <tr style={{ backgroundColor: "#f2f2f2" }}>
                            <td
                              className="text-left font-weight-bold"
                              style={{
                                width: "80px", // 96px -> 80px (reduzido ~17%)
                                borderTop: "2px solid #dee2e6",
                                ...headerFontStyle,
                                ...leftCellPadding
                              }}
                            >
                              Contrato
                            </td>
                            <td
                              className="text-center font-weight-bold"
                              style={{
                                width: "110px", // 90px -> 110px (aumentado ~22%)
                                borderTop: "2px solid #dee2e6",
                                ...headerFontStyle
                              }}
                            >
                              Contrato CIP
                            </td>
                            <td
                              className="text-left font-weight-bold"
                              style={{
                                width: "170px", // 200px -> 170px (reduzido ~15%)
                                borderTop: "2px solid #dee2e6",
                                ...headerFontStyle,
                                ...leftCellPadding
                              }}
                            >
                              Consignatária
                            </td>
                            <td
                              className="text-left font-weight-bold"
                              style={{
                                width: "84px", // 105px - 20%
                                borderTop: "2px solid #dee2e6",
                                ...headerFontStyle,
                                ...leftCellPadding
                              }}
                            >
                              CNPJ
                            </td>
                            <td
                              className="text-right font-weight-bold"
                              style={{
                                width: "96px", // 120px - 20%
                                borderTop: "2px solid #dee2e6",
                                ...headerFontStyle
                              }}
                            >
                              Vlr Parcela
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={5} style={{
                              borderBottom: "2px solid #dee2e6",
                              padding: 0,
                              height: "2px",
                              background: "#dee2e6"
                            }}></td>
                          </tr>
                        </thead>
                        <tbody>
                          {contratos &&
                            contratos.map((contrato, i) => {
                              const isSelected = clickedTr.nrContrato === contrato?.nrContrato;
                              return (
                                <tr
                                  key={i}
                                  className={isSelected ? "bg-secondary text-light" : ""}
                                  style={getRowZebraStyle(i, isSelected)}
                                  onClick={() => {
                                    handleContrato(contrato);
                                  }}
                                  onDoubleClick={() => {
                                    handleContrato(contrato);
                                  }}
                                >
                                  <td
                                    id={i}
                                    className="text-left"
                                    style={{
                                      width: "80px", // 96px -> 80px
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      ...tableFontStyle,
                                      ...leftCellPadding
                                    }}
                                  >
                                    {contrato?.nrContrato}
                                  </td>
                                  <td
                                    id={i}
                                    className="text-center"
                                    style={{
                                      width: "110px", // 90px -> 110px
                                      padding: "0 2px",
                                      verticalAlign: "middle",
                                      ...tableFontStyle
                                    }}
                                  >
                                    <input
                                      type="text"
                                      value={contrato?.contrato_cip || ""}
                                      onChange={e => handleContratoCipChange(e, contrato, i)}
                                      maxLength={40}
                                      tip={"Informe o contrato CIP caso seja diferente do contrato exibido"}
                                      style={{
                                        width: "100%",
                                        minWidth: "60px", // aumentada proporcionalmente
                                        maxWidth: "110px", // 110px
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                        padding: "2px 2px",
                                        fontSize: "13px",
                                        background: isSelected ? "#e9ecef" : "#fff",
                                        color: "#222",
                                        textAlign: "center"
                                      }}
                                      onClick={e => e.stopPropagation()}
                                      onDoubleClick={e => e.stopPropagation()}
                                      ref={el => (contratoCipRefs.current[i] = el)}
                                      inputMode="text"
                                      pattern="[a-zA-Z0-9]*"
                                    />
                                  </td>
                                  <td
                                    id={i}
                                    className="text-left"
                                    style={{
                                      width: "170px", // 200px -> 170px
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      ...tableFontStyle,
                                      ...leftCellPadding
                                    }}
                                    title={contrato?.nmConsignataria}
                                  >
                                    {contrato?.nmConsignataria}
                                  </td>
                                  <td
                                    id={i}
                                    className="text-left"
                                    style={{
                                      width: "84px", // 105px - 20%
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      ...tableFontStyle,
                                      ...leftCellPadding
                                    }}
                                  >
                                    {contrato?.nrCnpj}
                                  </td>
                                  <td
                                    id={i}
                                    className="text-right"
                                    style={{
                                      width: "96px", // 120px - 20%
                                      ...tableFontStyle
                                    }}
                                  >{`R$ ${parseFloat(contrato?.vlParcelaPort).toFixed(
                                    2
                                  )}`}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </fieldset>
                ))}
              <Buttons
                first="Voltar"
                second="Simular"
                // disabledSecond={naoEnviar}
                goBack={goBack}
                submit={submit}
              />
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

function mapStateToProps(state) {
  return {
    detalhes: state.dados.detalhes,
    proposta: state.dados.proposta,
  };
}

export default connect(mapStateToProps)(Form);
